import React from 'react';
import { Container, Card, Text, VStack } from "@chakra-ui/react"

export default function ShippingAndDelivery() {
    return (
        <>
            <Container maxW='8xl' my='6'>
                <VStack w='100%' spacing='4'>
                    <Card p='5' w='100%'>
                        <Text fontSize='2xl' fontWeight='800' className='customfont'>Shipping and Delivery</Text>
                    </Card>
                    <Card p='5' w='100%'>
                        <VStack w='100%' spacing='4' alignItems='start'>

                            <Text>Last updated on August 1 2024</Text>

                            <Text>For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only.</Text>

                            <Text>Orders are shipped within 8-14 days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms. M/S SHARDA PRINTERS is not liable for any delay in delivery by the courier company / postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 8-14 days rom the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on 7004637878 or vocalthread@gmail.com</Text>
                        </VStack>
                    </Card>
                </VStack>
            </Container>
        </>
    )
}
